import { message } from 'antd'
import { fetchUtil as fetch } from 'src/utils/fetch'
import { saveAuditData } from 'src/api/audit'

export const getLayout = async (providerCountry, layoutType) => {
  try {
    const { data } = await fetch(
      `/metaverse-rooms/layout/${layoutType}/${providerCountry}`
    )
    return data
  } catch (e) {
    message.error('get Layout error')
  }
}

export const getLayoutSection = async (id) => {
  try {
    const { data } = await fetch(
      `/metaverse-rooms/layout/section/${id}?page=0&size=1000`
    )
    return data
  } catch (e) {
    console.error('get Layout Section ', e)
  }
}

export const saveEditLayout = async (layoutId, id, values, image) => {
  try {
    const input = new FormData()
    input.append(
      'sectionDto',
      new Blob(
        [
          JSON.stringify({
            id: id,
            name: values.name,
            title: values.title,
            description: values.description,
            thumbnailSize: values.thumbnailSize,
            type: values.type,
            sectionId: values.sectionId,
            viewAll: values.viewAll,
            autoShuffle: values.autoShuffle,
            enable: values.enable,
          }),
        ],
        {
          type: 'application/json',
        }
      )
    )
    if (image !== null) {
      input.append('thumbImage', image)
    }

    const { data } = await fetch(
      `/metaverse-rooms/layout/section/${layoutId}`,
      {
        method: 'POST',
        body: input,
        headers: {
          role: 'ADMIN',
        },
      }
    )
    saveAuditData('EDIT', 'LAYOUT', values.name)
    message.success('Success Section Edit!')
    return 'success'
  } catch (e) {
    message.error('Edit Section error!')
    return 'failed'
  }
}

export const saveAddSectionItemLayout = async (
  sectionId,
  sectionItems,
  autoShuffle
) => {
  try {
    const input = {
      id: sectionId,
      sectionItem: sectionItems,
      autoShuffle: autoShuffle,
    }
    await fetch('/metaverse-rooms/layout/section/item', {
      method: 'POST',
      body: JSON.stringify(input),
      headers: {
        role: 'ADMIN',
      },
    })
    saveAuditData('ADD', 'LAYOUT-SECTION', sectionId)
    return 'success'
  } catch (e) {
    return 'failed'
  }
}

export const handleLayoutOrder = async (layoutId, prevOrder, newOrder) => {
  try {
    await fetch(
      `/metaverse-rooms/layout/order/${layoutId}/${prevOrder}/${newOrder}`,
      {
        method: 'PATCH',
        headers: {
          role: 'ADMIN',
        },
      }
    )
    return 'success'
  } catch (e) {
    console.log('error in handle layout', e)
    return 'failed'
  }
}

export const deleteSection = async (layoutId, sectionId) => {
  try {
    await fetch(`/metaverse-rooms/layout/${layoutId}/${sectionId}`, {
      method: 'DELETE',
      headers: {
        role: 'ADMIN',
      },
    })
    return 'success'
  } catch (e) {
    console.log('error in delete section', e)
    return 'failed'
  }
}
export const deleteSectionItem = async (sectionId, index) => {
  try {
    await fetch(`/metaverse-rooms/layout/section/${sectionId}/${index}`, {
      method: 'DELETE',
      headers: {
        role: 'ADMIN',
      },
    })
    return 'success'
  } catch (e) {
    console.log('error in delete section item', e)
    return 'failed'
  }
}
